enum CotacaoObservacoesEnum {
  Pacote = 'Pacote',
  TabelaPropriaOperadora = 'TabelaPropriaOperadora',
  ProjetoOrizon = 'ProjetoOrizon',
  Outros = 'Outros',
  ContaAbertaTabelaPropria = 'ContaAbertaTabelaPropria',
  ContaAbertaTresCotacoes = 'ContaAbertaTresCotacoes',
}

export default CotacaoObservacoesEnum
